import { createSeries, fillUnfilledSeries, getPostsForDates, getDateToCheckAgainst } from "./utils";
import moment from "moment";


export const formatLikes = (tweetStats, timeFrame, mode="personal") => {

  let likesLineSeries = createSeries(timeFrame);
    let currentLikesCount = 0;
    likesLineSeries = likesLineSeries.map((dataPoint, i, lSeries) => {
      if (tweetStats && tweetStats.length > 0) {
        let datedTweets = getPostsForDates(tweetStats, mode, dataPoint);
        
        if (datedTweets?.length > 0) {
          currentLikesCount = dataPoint.likes = datedTweets?.reduce(
            (prevValue, currentValue, i) => {
              return prevValue += ((datedTweets?.[i]?.numLikes ?? 0))
            }, 0
          );
          dataPoint.y = currentLikesCount;

          //fillUnfilledSeries(currentLikesCount, i, likesLineSeries, "likes");
        } else {
          dataPoint.likes = dataPoint.y = 0;
          //fillUnfilledSeries(currentLikesCount, i, likesLineSeries, "likes");
        }
      }
    
    return dataPoint;
  });
  
  likesLineSeries.map((dp, i) => {
    dp.y = dp.likes = dp.likes || 0; 
    dp.x = i + 1;
  });

    return likesLineSeries;
}

export const formatFollowers = (accountStats, timeFrame, mode="personal") => {

  // console.log('formatFollowers - accountStats:', accountStats)

  let followerLineSeries = createSeries(timeFrame);
  let currentFollowerCount = 0;
  followerLineSeries = followerLineSeries.map((dataPoint, i, fSeries) => {
    if (accountStats && accountStats.length > 0) {
      let index = accountStats.findIndex((n) => {
        
        const toCheckDateAgainst = (mode=="personal") && n?.dateFetched?.toDate
        ? n?.dateFetched?.toDate()
        : new Date().setTime(n.dateFetched?._seconds*1000)
        ;
        
        return moment.utc(toCheckDateAgainst)?.format("MMM. Do ’YY") === dataPoint.date;     
      });
      
      //console.log('currentFollowerCount:', currentFollowerCount)
      if (index != -1) {
        currentFollowerCount = dataPoint.followerCount = ((accountStats?.[index]?.followerCount) ? accountStats?.[index]?.followerCount : currentFollowerCount); //some followerCount may be undefined.
        dataPoint.y = currentFollowerCount;
        fillUnfilledSeries(currentFollowerCount, i, followerLineSeries, "followerCount");
      } else if (i == fSeries.length - 1) {
        fillUnfilledSeries(currentFollowerCount, i, followerLineSeries, "followerCount");
      }
      //console.log('followerCount:', dataPoint.followerCount) 
    }
    return dataPoint;
  });
  
  followerLineSeries.map((dp, i) => {
    dp.y =  dp.followerCount = dp.followerCount || 0;
    dp.x = i + 1;
  });
  
  //console.log('formatFollowers - followerLineSeries:', followerLineSeries)

  return followerLineSeries;
}

export const formatEngagement = (tweetStats, timeFrame, mode="personal") => {

  let engagementLineSeries = createSeries(timeFrame);
  let currentEngagementCount = 0;
  engagementLineSeries = engagementLineSeries.map((dataPoint,i, eSeries) => {
    if (tweetStats && tweetStats.length > 0) {
      let datedTweets = getPostsForDates(tweetStats, mode, dataPoint);
      
      if (datedTweets.length > 0) {
        currentEngagementCount = dataPoint.engagementCount = datedTweets.reduce(
          (prevValue, currentValue, i) => {
            return prevValue += ((datedTweets?.[i]?.numLikes ?? 0) +
            (datedTweets?.[i]?.totalShares ?? 0) +
            (datedTweets?.[i]?.numComments ?? 0))
          }, 0
        );
        dataPoint.y = currentEngagementCount;
        //fillUnfilledSeries(currentEngagementCount, i, engagementLineSeries, "engagementCount");
      } else {
        dataPoint.engagementCount = dataPoint.y = 0;
        //fillUnfilledSeries(currentEngagementCount, i, engagementLineSeries, "engagementCount");
      }
    }
    return dataPoint;
  });
  
  engagementLineSeries.map((dp, i) => {
    dp.engagementCount = dp.y = dp.engagementCount || 0; 
    dp.x = i + 1;
  });

  // console.log('engagementLineSeries:', engagementLineSeries);

  return engagementLineSeries;
}

export const formatNbPosts = (tweetStats, timeFrame, mode="personal") => {

    // console.log("tweetStats", tweetStats);

    let postsLineSeries = createSeries(timeFrame);
    let currentPostsCount = 0;
    postsLineSeries = postsLineSeries.map((dataPoint, i, pSeries) => {
      if (tweetStats && tweetStats.length > 0) {
        // let index = tweetStats.findIndex((n) => {
        //   const toCheckDateAgainst = getDateToCheckAgainst(n, mode);
        //   return toCheckDateAgainst === dataPoint.date; 
        // });
        let datedTweets = getPostsForDates(tweetStats, mode, dataPoint);
        if (datedTweets?.length > 0) {
            currentPostsCount = dataPoint.postCount = datedTweets.reduce((prevNoPost,currentNoPost, j ,arr) => {
              const tweetDate = getDateToCheckAgainst(arr?.[j], mode);
              if (tweetDate === dataPoint.date) return prevNoPost + 1;
              return prevNoPost;
            }, 0
          );
        } else {
          dataPoint.postCount = 0;
          dataPoint.y = 0;
        }
      }
       return dataPoint;
    });
    
    postsLineSeries.map((dp, i) => {
      dp.postCount = dp.y = dp.postCount || 0;
      dp.x = i + 1;
    });

    return postsLineSeries;
}